import type { TariffPathId } from './types'
import { UTILITY_TARIFF_GROUPS_LIST_PATH } from './constants'

export function utilityTariffNewVersionPath(groupId: TariffPathId) {
  return `${UTILITY_TARIFF_GROUPS_LIST_PATH}/${groupId}/versions/create`
}

export function utilityTariffVersionEditPath(groupId: TariffPathId, tariffId: TariffPathId) {
  return `${UTILITY_TARIFF_GROUPS_LIST_PATH}/${groupId}/versions/${tariffId}/edit`
}
